class CredentialsModel {
  constructor(public username: string, public password: string, public selectedCountry: string) {
  }

  public allowActiveDirectoryLoginAttempts?: boolean;
}

export { CredentialsModel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/login/_domain/models/credentials-model.ts